var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "baseInfo" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass(
                    "vesselCode,vesselName,vesselNameCn,voyageNo,voyageLeg"
                  ),
                  attrs: { label: _vm.$t("home.vesselAndVoyage") },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", disabled: true },
                    model: {
                      value: _vm.vessNameVoy,
                      callback: function ($$v) {
                        _vm.vessNameVoy = $$v
                      },
                      expression: "vessNameVoy",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("saillingDate"),
                  attrs: {
                    prop: "saillingDate",
                    label: _vm.$t("home.sailingTime"),
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder: "",
                      disabled: true,
                    },
                    model: {
                      value: _vm.form.saillingDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "saillingDate", $$v)
                      },
                      expression: "form.saillingDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("eta"),
                  attrs: { prop: "eta", label: _vm.$t("home.arrivalTime") },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      disabled: true,
                      type: "date",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder: "",
                    },
                    model: {
                      value: _vm.form.eta,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "eta", $$v)
                      },
                      expression: "form.eta",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdPerson"),
                  attrs: {
                    prop: "bookingFwdPerson",
                    label: _vm.$t("home.contactCustomer"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.bookingFwdPerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdPerson", $$v)
                      },
                      expression: "form.bookingFwdPerson",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdTel"),
                  attrs: {
                    prop: "bookingFwdTel",
                    label: _vm.$t("home.mobilePhone"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.bookingFwdTel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdTel", $$v)
                      },
                      expression: "form.bookingFwdTel",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bookingFwdEmail"),
                  attrs: {
                    prop: "bookingFwdEmail",
                    label: _vm.$t("home.email"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.bookingFwdEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingFwdEmail", $$v)
                      },
                      expression: "form.bookingFwdEmail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("actualShipper"),
                  attrs: {
                    prop: "actualShipper ",
                    label: _vm.$t("home.people"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.actualShipper,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "actualShipper", $$v)
                      },
                      expression: "form.actualShipper ",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("bkNo"),
                  attrs: { prop: "bkNo", label: _vm.$t("home.bkNo") },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", maxlength: "20" },
                    model: {
                      value: _vm.form.bkNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bkNo", $$v)
                      },
                      expression: "form.bkNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("blNo"),
                  attrs: { prop: "blNo", label: _vm.$t("home.blNo") },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", maxlength: "50" },
                    model: {
                      value: _vm.form.blNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "blNo", $$v)
                      },
                      expression: "form.blNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "bookingType",
                    label: _vm.$t("home.bookingType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("bookingType"),
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.form.bookingType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bookingType", $$v)
                        },
                        expression: "form.bookingType",
                      },
                    },
                    _vm._l(_vm.bookingTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "transportationTerms",
                    label: _vm.$t("home.transportationTerms"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("transportationTerms"),
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.form.transportationTerms,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "transportationTerms", $$v)
                        },
                        expression: "form.transportationTerms",
                      },
                    },
                    _vm._l(_vm.transportationTermsList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: String(item), value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { prop: "paidPalce", label: _vm.$t("home.paidPalce") },
                },
                [
                  _c("glPort", {
                    class: _vm.inputClass("paidPalce"),
                    model: {
                      value: _vm.form.paidPalce,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paidPalce", $$v)
                      },
                      expression: "form.paidPalce",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "paidType", label: _vm.$t("home.paidType") } },
                [
                  _c(
                    "el-select",
                    {
                      class: _vm.inputClass("paidType"),
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.form.paidType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "paidType", $$v)
                        },
                        expression: "form.paidType",
                      },
                    },
                    _vm._l(_vm.paidTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("deliveryDocumentMethod"),
                  attrs: {
                    prop: "deliveryDocumentMethod",
                    label: _vm.$t("home.documentType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.deliveryDocumentMethod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deliveryDocumentMethod", $$v)
                        },
                        expression: "form.deliveryDocumentMethod",
                      },
                    },
                    _vm._l(_vm.documentTypeList, function (item) {
                      return _c("el-option", {
                        key: item.codeValue,
                        attrs: {
                          label:
                            _vm.language === "zh"
                              ? item.displayValueCn
                              : item.displayValue,
                          value: Number(item.codeValue),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("wbillNo"),
                  attrs: { prop: "wbillNo", label: _vm.$t("home.documentNo") },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.wbillNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "wbillNo", $$v)
                      },
                      expression: "form.wbillNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("agreementNo"),
                  attrs: {
                    prop: "agreementNo",
                    label: _vm.$t("home.agreementNo"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.agreementNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "agreementNo", $$v)
                      },
                      expression: "form.agreementNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("freeTimeNo"),
                  attrs: { prop: "freeTimeNo", label: _vm.$t("home.ft") },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50" },
                    model: {
                      value: _vm.form.freeTimeNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "freeTimeNo", $$v)
                      },
                      expression: "form.freeTimeNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("sales"),
                  attrs: { prop: "sales", label: _vm.$t("home.sales") },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", maxlength: "50" },
                    model: {
                      value: _vm.form.sales,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sales", $$v)
                      },
                      expression: "form.sales",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("expCustomsCargoType"),
                  attrs: {
                    prop: "expCustomsCargoType",
                    label: _vm.$t("home.cargoType"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.form.expCustomsCargoType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "expCustomsCargoType", $$v)
                        },
                        expression: "form.expCustomsCargoType",
                      },
                    },
                    _vm._l(_vm.cargoListType, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: Number(item.code) },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("por"),
                  attrs: { prop: "por", label: _vm.$t("home.por") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.por,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "por", $$v)
                      },
                      expression: "form.por",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("pol"),
                  attrs: { prop: "pol", label: _vm.$t("home.pol") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.pol,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pol", $$v)
                      },
                      expression: "form.pol",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("pod"),
                  attrs: { prop: "pod", label: _vm.$t("home.pod") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.pod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pod", $$v)
                      },
                      expression: "form.pod",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("del"),
                  attrs: { prop: "del", label: _vm.$t("home.del") },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.del,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "del", $$v)
                      },
                      expression: "form.del",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("porName"),
                  attrs: { prop: "porName" },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.webBkExtendComs[0].porName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.webBkExtendComs[0], "porName", $$v)
                      },
                      expression: "form.webBkExtendComs[0].porName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("polName"),
                  attrs: { prop: "polName" },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.webBkExtendComs[0].polName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.webBkExtendComs[0], "polName", $$v)
                      },
                      expression: "form.webBkExtendComs[0].polName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("podName"),
                  attrs: { prop: "podName" },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.webBkExtendComs[0].podName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.webBkExtendComs[0], "podName", $$v)
                      },
                      expression: "form.webBkExtendComs[0].podName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("delName"),
                  attrs: { prop: "delName" },
                },
                [
                  _c("glPort", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.webBkExtendComs[0].delName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.webBkExtendComs[0], "delName", $$v)
                      },
                      expression: "form.webBkExtendComs[0].delName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "10px 0 16px 0" } },
        [
          _c(
            "el-checkbox",
            {
              class: _vm.inputClass("vipFlag"),
              attrs: { "true-label": 1, "false-label": 0 },
              model: {
                value: _vm.form.vipFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "vipFlag", $$v)
                },
                expression: "form.vipFlag",
              },
            },
            [_vm._v("\n      VIP\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              class: _vm.inputClass("masterBlFlag"),
              attrs: { "true-label": 1, "false-label": 0 },
              model: {
                value: _vm.form.masterBlFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "masterBlFlag", $$v)
                },
                expression: "form.masterBlFlag",
              },
            },
            [_vm._v("\n      NVOCC\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }